
import { memo, useMemo, useRef } from "react";
import { BirdieGameGroup, BirdieRecord } from "@/types";
import GameCard from "./GameCard";
import { getUserGameStatus } from "./GameStatusCalculator";

interface GamesListProps {
  activeGames: BirdieGameGroup[];
  birdieRecords: BirdieRecord[];
  onViewGame: (gameId: string) => void;
  currentUserId?: string;
}

// Memoized component to prevent unnecessary re-renders
const GamesList = memo(({ activeGames, birdieRecords, onViewGame, currentUserId }: GamesListProps) => {
  const listRef = useRef<HTMLDivElement>(null);
  
  // Create game statuses with proper record filtering
  const gameStatuses = useMemo(() => 
    activeGames.map(game => {
      // Calculate status using all available records
      // The getUserGameStatus function will filter for game-specific records
      const status = getUserGameStatus(game, birdieRecords, currentUserId);
      
      return { game, status };
    }),
    [activeGames, birdieRecords, currentUserId]
  );
  
  return (
    <div ref={listRef} className="space-y-3">
      {gameStatuses.map(({ game, status }) => (
        <GameCard
          key={game.id}
          game={game}
          status={status}
          onViewGame={onViewGame}
          currentUserId={currentUserId}
        />
      ))}
    </div>
  );
});

// Add display name for debugging
GamesList.displayName = "GamesList";

export default GamesList;
